export function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
export function forEach(list, callback) {
  Array.prototype.forEach.call(list, callback);
}